export default theme => ({
  root: {
    paddingTop: theme.spacing.unit * 5
  }
});



// WEBPACK FOOTER //
// ./src/pages/Onboarding/Success/styles.js